exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".c-loading-circle--profile {\n  transform: translate(0, 2rem);\n  margin: 0 auto; }\n", "", {"version":3,"sources":["/home/vsts/work/1/s/src/containers/App/src/containers/App/App.scss"],"names":[],"mappings":"AACA;EACI,8BAA6B;EAE7B,eAAc,EACjB","file":"App.scss","sourcesContent":["@import \"variables\"; @import \"mixins\";\n.c-loading-circle--profile {\n    transform: translate(0, 2rem);\n\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"variables/"; @import /"mixins/";","includePaths":["/home/vsts/work/1/s/src/scss"]}!./src/containers/App/App.scss
// module id = 405
// module chunks = 0